import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingTrackerService {
  private readonly _active = signal(0);

  readonly activeCount = this._active.asReadonly();
  readonly isLoading = computed(() => this._active() > 0);

  inc() {
    this._active.update((v) => v + 1);
  }

  dec() {
    this._active.update((v) => Math.max(0, v - 1));
  }
}
